import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import Form from '../Form/Form';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import css from './AddDocumentModal.module.css';
import FieldSelect from '../FieldSelect/FieldSelect';
import { testFolderData } from '../../util/circleHelper';
import { FormattedMessage } from '../../util/reactIntl';
import Button from '../Button/Button';
import DragAndDrop from '../DragAndDrop/DragAndDrop';
import IconCollection from '../IconCollection/IconCollection';
import { required } from '../../util/validators';

const ACCEPT_FILES = '.pdf, .doc, .docx';

const dragAndDropHandler = (
  file,
  form,
  onUploadDocument
) => {
  onUploadDocument({ id: `${file.name}_${Date.now()}`, file }).then(response => {
    const { secure_url, public_id, format } = response;
    const documentData = {
      documentURL: secure_url,
      documentId: public_id,
      documentType: format,
    };
    form.batch(() => {
      form.change(`selectedFile`, URL.createObjectURL(file));
      form.change("document", documentData);
    });
  });
};

const AddDocumentForm = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        form,
        handleSubmit,
        onUploadDocument,
        uploadedDocument,
        uploadError,
        updateDocumentInProgress,
        updateDocumentError,
        uploadInProgress,
        invalid,
        values,
        allGroupFolders,
        intl
      } = fieldRenderProps;

      const submitDisabled = invalid || updateDocumentInProgress || uploadInProgress || !values.document;
      
      return (
        <Form onSubmit={values => handleSubmit(values, form)}>
          {updateDocumentError}
          <div>
            <DragAndDrop
              handleDrop={files => dragAndDropHandler(files[0], form, onUploadDocument)}
              acceptedFileType={'document'}
            >
              <div className={css.uploadWrapper}>
                <div className={css.boxUploader}>
                  <div className={css.dragText}>
                    {uploadedDocument ? (
                      <div></div>
                    ) : (
                      <Field
                        accept={ACCEPT_FILES}
                        id="documentFile"
                        name="documentFile"
                        label={<FormattedMessage id="AddDocumentModal.addDocument" />}
                        type="file"
                        form={null}
                        uploadImageError={uploadError}
                        disabled={false}
                      >
                        {fieldProps => {
                          const { accept, id, input, label, disabled } = fieldProps;
                          const { name, type } = input;
                          const onChange = e => {
                            const file = e.target.files[0];
                            if (file) {
                              onUploadDocument({ id: `${file.name}_${Date.now()}`, file }).then(
                                response => {
                                  const { secure_url, public_id, format } = response;
                                  const documentData = {
                                    documentURL: secure_url,
                                    documentId: public_id,
                                    documentType: format ?? 'doc',
                                  };
                                  form.batch(() => {
                                    form.change(`selectedFile`, URL.createObjectURL(file));
                                    form.change("document", documentData);
                                  });
                                }
                              );
                            }
                          };
                          return (
                            <div className={css.uploadAvatarWrapper}>
                              <label className={css.label} htmlFor={id}>
                                {label}
                              </label>
                              <div className={css.uploadAvatarInputWrapper}>
                                <div>
                                  {values?.selectedFile ? (
                                    <iframe
                                      src={`https://docs.google.com/gview?url=${values?.document?.documentURL}&embedded=true`}
                                    />
                                  ) : (
                                    <>
                                      <IconCollection name="uploadIcon" />
                                      <div>
                                        <h4>
                                          <FormattedMessage id="AddDocumentModal.dropFileTitle" />
                                        </h4>
                                        <p>
                                          <FormattedMessage id="AddDocumentModal.dropFileDescription" />
                                        </p>
                                      </div>
                                    </>
                                  )}
                                  <Button
                                    className={css.chooseFileButton}
                                    inProgress={uploadInProgress}
                                  >
                                    <FormattedMessage id="AddDocumentModal.dropFileButton" />
                                  </Button>
                                </div>
                                <input
                                  accept={accept}
                                  id={id}
                                  name={name}
                                  className={css.uploadAvatarInput}
                                  disabled={disabled}
                                  onChange={onChange}
                                  type={type}
                                />
                              </div>
                              {typeof uploadError == 'string' && uploadError}
                            </div>
                          );
                        }}
                      </Field>
                    )}
                  </div>
                </div>
              </div>
            </DragAndDrop>
            <FieldTextInput
              className={css.inputBox}
              id={'documentName'}
              name={'documentName'}
              type="text"
              placeholder="Type document name..."
              label={<FormattedMessage id="AddDocumentModal.documentName" />}
              maxLength={45}
              minLength={1}
              validate={required(
                intl.formatMessage({
                  id: 'AddDocumentForm.documentNameRequired',
                })
              )}
            />
            {/* test data for implementing UI */}
            <FieldSelect
              id={'folderId'}
              name={'folderId'}
              validate={required(
                intl.formatMessage({
                  id: 'AddDocumentForm.folderRequired',
                })
              )}
              className={css.inputBox}
              label={<FormattedMessage id="AddDocumentModal.selectFolder" />}
            >
              <option key={'item.id'} value={''} disabled>
                Select folder...
              </option>
              {allGroupFolders?.map(item => (
                <option key={item.id} value={item.folderId}>
                  {item.folderName}
                </option>
              ))}
            </FieldSelect>
          </div>
          <Button
            className={css.groupButton}
            type="submit"
            inProgress={updateDocumentInProgress}
            disabled={submitDisabled}
          >
            <FormattedMessage id="AddDocumentModal.saveDocuments" />
          </Button>
        </Form>
      );
    }}
  />
);

export default AddDocumentForm;
